import { useSelector } from 'react-redux';
import { getAllAccounts } from '../selectors/accounts';

const useAccountsMap = () => useSelector(getAllAccounts);

export default useAccountsMap;